import * as Sentry from '@sentry/react';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';
import { useHomeGamesWidget } from '@swf/poker';

export const ERROR_CODE = {
  noSession: { code: '', title: 'No session provided' },
  invalidSession: { code: 'SE102', title: 'Invalid Session' },
  lobbyDataUnauthorised: { code: 'SE103', title: 'Lobby Data Unauthorised' }
};
export const ERROR_MESSAGE = 'Home Games Stuck';

const useSessionLogger = () => {
  const { widgetSelect } = useHomeGamesWidget();
  const desktopEmbedded = useSelector(select.device.isDesktopEmbedded);
  const hasLobbyDataError = useSelector((rootState: RootState) =>
    widgetSelect.error(rootState, 'critical')
  );
  const { authSource } = useSelector(select.session.get);
  const isSessionLoading = useSelector(
    (rootState: RootState) => !!rootState.loading?.effects.auth.verifySession
  );
  const [errorCode, setErrorCode] = useState('');
  const errorLoggedRef = useRef('');

  useEffect(() => {
    if (desktopEmbedded && !isSessionLoading) {
      let errorCode;
      const hasSession = !!window.starsweb?.auth.token;

      if (hasLobbyDataError) {
        errorCode = ERROR_CODE.lobbyDataUnauthorised;
      } else if (hasSession) {
        errorCode = ERROR_CODE.invalidSession;
      } else {
        errorCode = ERROR_CODE.noSession;
      }

      setErrorCode(errorCode.code);
      if (errorLoggedRef.current !== errorCode.title) {
        // Don't log same error twice.
        errorLoggedRef.current = errorCode.title;
        /* 
        authSource - server - if session sent to the SSR is invalid
        hasSession - true - if starsweb.auth.token is provided
        */
        Sentry.captureException(new Error(ERROR_MESSAGE), {
          extra: { authSource, errorCode, hasSession }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSessionLoading]);

  return errorCode;
};

export default useSessionLogger;
